// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"17cb4f5b","666":"32e1a6c7","849":"3ff73db5","977":"ad7bfec7"}[chunkId] + ".chunk.js";
};